import styled from "styled-components";
import type { LockPositionT } from "utils/chart/getAxisControlPositions";

import { AXIS_INPUT_Z_INDEX } from "components/charts/components/AxisContainer/AxisContainer.constants";

export const LockIconWrapper = styled.div`
  position: absolute;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  border-radius: 100vmax;
  isolation: isolate;
  z-index: 3;
  pointer-events: auto;
`;

// For multi-product charts lock positions
export const MpLockWrapper = styled.div<{
  $lockPosition: LockPositionT;
  $variant: "min" | "max";
}>`
  position: absolute;
  pointer-events: auto;
  z-index: ${AXIS_INPUT_Z_INDEX}; // Keep date input above the legend, matching the single-axis Wrapper

  ${({ $lockPosition, $variant }) => {
    const { top, bottom, left, right } =
      $variant === "min" ? $lockPosition.min : $lockPosition.max;
    return `
      ${top != null ? `top: ${top}px;` : ""}
      ${bottom != null ? `bottom: ${bottom}px;` : ""}
      ${left != null ? `left: ${left}px;` : ""}
      ${right != null ? `right: ${right}px;` : ""}
    `;
  }}

  /* Reset all positioning from the single-axis Wrapper styles */
  .axis-locker {
    position: static !important;
  }
`;
